module.exports = __webpack_public_path__ + "img/2024.61628460.svg";